const StatCard = ({ title, value, trend, color }) => (
  <div className={`stat-card ${color}`}>
    <div>
      <p>{title}</p>
      <h3>{value}</h3>
      <span>{trend}</span>
    </div>
    <div className="stat-icon" />
  </div>
);

export default StatCard;
